import { createSelector } from 'reselect';

const getState = (state) => state.directOrder.data.repeatedFrom;

const getRepeatedFrom = createSelector(
  getState,
  (repeatedFrom) => repeatedFrom
);

export default {
  getRepeatedFrom,
};
